<template>
   <div>
      <div class="row mt-2">
         <div class="col-12" id="choose_which_products">
            Choose which products and how many to request below and someone from the SIMmersion team will get back to you soon with a quote
         </div>
      </div>
      <div class="row mt-4">
         <div class="col-4">
           <label class="text-dark mt-2" id="product">Product:</label>
         </div>
         <div class="col-8">
             <select v-model="sproduct" class="fullWidth">
                <option v-for="product in products" v-bind:value="product.ProductID">{{product.ProductName}}</option>
             </select>
         </div>
      </div>
      <div class="row mt-3" v-if="selectedproduct!==null&&selectedproduct.ProductID!==null">
         <div class="col-12 cartbox">
             <div class="row">
               <div class="col-3">
                   <img :src="selectedproduct.FullImage" width="100" height="100" @error="doGenericAvatar(fitem)" alt="Product Image" />
               </div>
                 <div class="col-9">
                    <p>
                      {{selectedproduct.Description}}
                    </p>
                    <p class="text-right">
                      <button class="btn btn-secondary btn-short" @click="doAddToCart(selectedproduct.ProductID,selectedproduct.ProductName)">Add</button>
                    </p>
                 </div>
             </div>
         </div>
      </div>
      <div class="row mt-3" v-show="cart.length>0">
        <div class="col-12 cartbox">
           <h4>Selected Items</h4>
           <div class="row mt-3">
             <div class="col-7">
               <span class="lowbold">Product</span></div>
               <div class="col-3">
                 <span class="lowbold">Number</span></div>
               <div class="col-2">
                 <span class="lowbold">Remove</span></div>
           </div>
           <div class="row mt-1" v-for="item in cart">
               <div class="col-7">
                 <div class="mt-2">
                   {{item.Name}}
                 </div>
               </div>
               <div class="col-3">
                   <input v-model="item.Number" />
               </div>
               <div class="col-2">
                 <div class="mt-2">
                   <button class="btn-transparent" @click="doRemoveFromCart(item.ProductID)"><font-awesome-icon size="lg" icon="times"></font-awesome-icon></button>
                 </div>
               </div>
           </div>
        </div>
      </div>

      <div class="row mt-3" v-show="cart.length>0">
         <div class="col-12 text-right">
            <button class="btn btn-primary btn-short" @click="doSubmit">Submit</button>
         </div>
      </div>
   </div>
</template>

<style scoped>
   .cartbox {
      border:1px solid #666;
      border-radius:10px;
      padding:1%;
   }
   .lowbold {
      font-weight:600;
   }
</style>

<script>
   export default {
      name: "ProductPurchaseRequest",
      props:["pool"],
      data() {
        return {
          selectedproduct:null,
          sproduct:null,
          products:[],
          cart:[]
        }
      },
      methods: {
        doAddToCart(ProductID,ProductName) {
          var prcart = this.cart.filter(p=>p.ProductID===ProductID);
          if (prcart.length>0) {
            prcart[0].Number++;
          }
          else {
            this.cart.push({Name: ProductName, ProductID: ProductID, Number: 1});
          }
        },
        doGenericAvatar: function(pr) {
          pr.FullImage="/genericCircle.png";
          this.$forceUpdate();
        },
        doRemoveFromCart: function(ProductID) {
          var toremove=-1;
          for(var x=0; x<this.cart.length; x++) {
            if (this.cart[x].ProductID===ProductID) {
              toremove=x;
            }
          }
          if (toremove>-1) {
            this.cart.splice(toremove,1);
          }
        },
        doSubmit() {

          var udata = JSON.parse(localStorage.getItem("udata"));

          var baddress="";
          var baddress2="";
          var saddress="";
          var saddress2="";

          try {
            baddress=this.pool.Address1.StreetAddress1;
          }
          catch(e) {}

          try {
            baddress2=this.pool.Address1.StreetAddress2;
          }
          catch(e) {}

          try {
            saddress=this.pool.Address1.StreetAddress1;
          }
          catch(e) {}

          try {
            bsddress2=this.pool.Address1.StreetAddress2;
          }
          catch(e) {}

          var fields = {
            ClientID: "00000000-0000-0000-0000-000000000000",
            LicensePoolID: this.pool.LicensePoolID,
            BStreetAddress1: baddress,
            BStreetAddress2: baddress2,
            BCity: this.pool.Address1.City,
            BState: this.pool.Address1.State,
            BZip: this.pool.Address1.Zip,
            BPhone: this.pool.Address1.Phone,
            SStreetAddress1: saddress,
            SStreetAddress2: saddress2,
            SCity: this.pool.Address1.City,
            SState: this.pool.Address1.State,
            SZip: this.pool.Address1.Zip,
            SPhone: this.pool.Address1.Phone,
            FirstName: udata.ClientName,
            LastName: "Purchase Request",
            CompanyName: "",
            Description: "",
            TaxExemptCode: "",
            Shipping: "0",
            IsGift: "false",
            PromoCode: "",
            Products: []
          };

          for (var co of this.cart) {
     
            fields.Products.push({
              "Key": co.ProductID,
              "Value": {
                licenseType: 4,
                licenseHours: 0,
                licenseQuantity: co.Number,
                licenseTerm: 365,
                dvdQuantity: 0,
                customPrice: null,
                planType: 0
              }
            });
          }   

          this.apiCommand([
            {
              Operation: "Order",
              Function: "Add",
              Fields: fields
            }
          ]).then(response=> {
            if (response.CommandResult != null) {
              var cr = JSON.parse(response.CommandResult);
              if (cr.returnObjects[0].returnObject.indexOf("|||") > -1) {
                var oparts = cr.returnObjects[0].returnObject.split("|||");

                this.cart=[];
                this.popDialog(0, "Purchase request submitted succesfully");

              }
              else {
              
                this.popDialog(1,cr.returnObjects[0].returnObject);
              }
            }
            else {
              this.popDialog(1,"A fatal problem occurred with creating the order");
            }
          }, function () { })
        },
        setup() {
          this.apiCommand([
             {
               Operation: "Product",
               Function: "GetAllPurchasableProducts",
               Fields: { }
             }
          ]).then(r=> {
            var cr=JSON.parse(r.CommandResult);
            var _products=JSON.parse(cr.returnObjects[0].returnObject);
            for(var product of _products) {
              product.FullImage="https://attachments.simmersion.com/"+product.ProductID;
            }
            _products.sort(function compare(a, b) {
              let comparison = 0;
              if (a.ProductName>b.ProductName) {
                comparison = 1;
              } else if (a.ProductName < b.ProductName) {
                comparison = -1;
              }
              return comparison;
            });
            _products.unshift({
              ProductID:null,
              ProductName:"--- Select ---"
            });
            this.products=_products;
          });
        }
      },
      watch: {
        sproduct:function() {
          this.selectedproduct=this.products.filter(p=>p.ProductID===this.sproduct)[0];
        }
      }
   }
</script>
